class FiltersDrawer extends HTMLElement {
  constructor() {
    super();

    this.mainElement = this.querySelector('#FacetFiltersFormMobile');
    this.triggerButton = this.querySelector('button.mobile-facets__open')
    this.bindEvents();
  }

  bindEvents() {
    this.triggerButton.addEventListener('click', this.openDrawer.bind(this))

    this.querySelectorAll('.mobile-facets__header-close-button, .modal-overlay').forEach((el) =>
      el.addEventListener('click', this.closeDrawer.bind(this))
    );
  }

  openDrawer(event) {
    this.classList.add('drawer__open');
    document.body.classList.add('overflow-hidden');
    document.body.classList.add('drawer__filters');
    this.mainElement.removeAttribute('tabindex')

    trapFocus(this.mainElement, this.querySelector('.mobile-facets__inner'));
  }

  closeDrawer(event) {
    this.classList.remove('drawer__open');
    document.body.classList.remove('overflow-hidden');
    document.body.classList.remove('drawer__filters');
    this.mainElement.setAttribute('tabindex', -1)

    trapFocus(this.mainElement, this.triggerButton);
  }
}

customElements.define('filters-drawer', FiltersDrawer);

class FacetFiltersForm extends HTMLElement {
  constructor() {
    super();
    this.onActiveFilterClick = this.onActiveFilterClick.bind(this);

    this.debouncedOnSubmit = debounce((event) => {
      this.onSubmitHandler(event);
    }, 500);

    const facetForm = this.querySelector('form');
    facetForm.addEventListener('input', this.debouncedOnSubmit.bind(this));

    const facetWrapper = this.querySelector('#FacetsWrapperDesktop');
    if (facetWrapper) facetWrapper.addEventListener('keyup', onKeyUpEscape);

    const priceFilterInputs = this.querySelectorAll('input[name="filter_price"]');

    priceFilterInputs.forEach((input) => {
      input.addEventListener('change', (e) => {
        let selectedPriceMin = [];
        let selectedPriceMax = [];
        priceFilterInputs.forEach((el) => {
          if (el.checked) {
            const val = el.value.split('-');
            const minVal = Number(val[0]);
            const maxVal = Number(val[1]);

            if (!selectedPriceMin.includes(minVal)) selectedPriceMin.push(minVal);
            if (!selectedPriceMax.includes(maxVal)) selectedPriceMax.push(maxVal);
          }
        });

        this.updatePriceRanges(selectedPriceMin[0], selectedPriceMax[selectedPriceMax.length - 1]);
      })
    })

    this.viewResultsButton = this.querySelector('.mobile-facets__actions button');
    if(this.viewResultsButton) {
      this.viewResultsButton.addEventListener('click', this.closeFiltersAndFocusToFirstVisibleProductCard.bind(this))
    }

    const sortContainer = this.querySelector('.mobile-facets__sorting-submenu');
    if(sortContainer) {
      const links = sortContainer.querySelectorAll("a");
      const lastLink = links[links.length - 1];

      sortContainer.addEventListener("keydown", function (e) {
        if (e.key === "Enter" || e.code === "Space") {
          e.preventDefault();
          const selectedOption = e.target.nextElementSibling.querySelector("input[name='sort_by']");
          selectedOption.checked = true;
          
          const event = new Event('input', { bubbles: true });
          selectedOption.dispatchEvent(event);
        }
      });

      links.forEach((link) => {
        link.addEventListener('click', (e) => {
          e.preventDefault();
          const selectedOption = e.target.closest('li').querySelector("input[name='sort_by']");
          selectedOption.checked = true;
          
          const event = new Event('input', { bubbles: true });
          selectedOption.dispatchEvent(event);
        })
      })

      lastLink?.addEventListener("keydown", function (e) {
        if (e.key === "Tab" && !e.shiftKey) {
          // Close the dropdown
          e.target.closest('details.mobile-facets__sort').removeAttribute('open');
        }
      });
    }
  }

  closeFiltersAndFocusToFirstVisibleProductCard(e) {
    this.closest('.mobile-facets__disclosure').querySelector('.mobile-facets__header-close-button').click()
    
    const firstProductLink = document.querySelector('#product-grid .product-card-wrapper .card__heading a');
    if (firstProductLink) {
      firstProductLink.setAttribute('tabindex', '-1')
      firstProductLink.focus();
    }
  }

  updatePriceRanges(min, max) {
    this.querySelector('[name="filter.v.price.gte"]').value = min;
    this.querySelector('[name="filter.v.price.lte"]').value = max;
    const event = document.createEvent("input");
    facetForm.dispatchEvent(event);
  }

  static setListeners() {
    const onHistoryChange = (event) => {
      const searchParams = event.state ? event.state.searchParams : FacetFiltersForm.searchParamsInitial;
      if (searchParams === FacetFiltersForm.searchParamsPrev) return;
      FacetFiltersForm.renderPage(searchParams, null, false);
    };
    window.addEventListener('popstate', onHistoryChange);
  }

  static toggleActiveFacets(disable = true) {
    document.querySelectorAll('.js-facet-remove').forEach((element) => {
      element.classList.toggle('disabled', disable);
    });
  }

  static renderPage(searchParams, event, updateURLHash = true) {
    FacetFiltersForm.searchParamsPrev = searchParams;
    const sections = FacetFiltersForm.getSections();
    const countContainer = document.getElementById('ProductCount');
    const countContainerDesktop = document.getElementById('ProductCountDesktop');
    document.getElementById('ProductGridContainer').querySelector('.collection').classList.add('loading');
    if (countContainer) {
      countContainer.classList.add('loading');
    }
    if (countContainerDesktop) {
      countContainerDesktop.classList.add('loading');
    }

    sections.forEach((section) => {
      const url = `${window.location.pathname}?section_id=${section.section}&${searchParams}`;
      const filterDataUrl = (element) => element.url === url;

      FacetFiltersForm.filterData.some(filterDataUrl)
        ? FacetFiltersForm.renderSectionFromCache(filterDataUrl, event)
        : FacetFiltersForm.renderSectionFromFetch(url, event);
    });

    if (updateURLHash) FacetFiltersForm.updateURLHash(searchParams);
  }

  static renderSectionFromFetch(url, event) {
    fetch(url)
      .then((response) => response.text())
      .then((responseText) => {
        const html = responseText;
        FacetFiltersForm.filterData = [...FacetFiltersForm.filterData, { html, url }];
        FacetFiltersForm.renderFilters(html, event);
        FacetFiltersForm.renderProductGridContainer(html);
        FacetFiltersForm.renderProductCount(html);
        if (typeof initializeScrollAnimationTrigger === 'function') initializeScrollAnimationTrigger(html.innerHTML);
      });
  }

  static renderSectionFromCache(filterDataUrl, event) {
    const html = FacetFiltersForm.filterData.find(filterDataUrl).html;
    FacetFiltersForm.renderFilters(html, event);
    FacetFiltersForm.renderProductGridContainer(html);
    FacetFiltersForm.renderProductCount(html);
    if (typeof initializeScrollAnimationTrigger === 'function') initializeScrollAnimationTrigger(html.innerHTML);
  }

  static renderProductGridContainer(html) {
    document.getElementById('ProductGridContainer').innerHTML = new DOMParser()
      .parseFromString(html, 'text/html')
      .getElementById('ProductGridContainer').innerHTML;

    document
      .getElementById('ProductGridContainer')
      .querySelectorAll('.scroll-trigger')
      .forEach((element) => {
        element.classList.add('scroll-trigger--cancel');
      });
  }

  static renderProductCount(html) {
    const count = new DOMParser().parseFromString(html, 'text/html').getElementById('ProductCount').innerHTML;
    const container = document.getElementById('ProductCount');
    const containerDesktop = document.getElementById('ProductCountDesktop');
    container.innerHTML = count;
    container.classList.remove('loading');
    if (containerDesktop) {
      containerDesktop.innerHTML = count;
      containerDesktop.classList.remove('loading');
    }
  }

  static renderFilters(html, event) {
    const parsedHTML = new DOMParser().parseFromString(html, 'text/html');

    const facetDetailsElements = parsedHTML.querySelectorAll(
      '#FacetFiltersForm .js-filter, #FacetFiltersFormMobile .js-filter, #FacetFiltersPillsForm .js-filter'
    );
    const matchesIndex = (element) => {
      const jsFilter = event ? event.target.closest('.js-filter') : undefined;
      return jsFilter ? element.dataset.index === jsFilter.dataset.index : false;
    };
    const facetsToRender = Array.from(facetDetailsElements).filter((element) => !matchesIndex(element));
    const countsToRender = Array.from(facetDetailsElements).find(matchesIndex);

    facetsToRender.forEach((element) => {
      document.querySelector(`.js-filter[data-index="${element.dataset.index}"]`).innerHTML = element.innerHTML;
    });

    FacetFiltersForm.renderActiveFacets(parsedHTML);
    FacetFiltersForm.renderAdditionalElements(parsedHTML);

    // sync bits filters if exists
    const bitsFilterPills = document.querySelector('bits-collection-filters');
    if(bitsFilterPills) {
      bitsFilterPills.syncWithFilterDrawer();
    }

    if (countsToRender) FacetFiltersForm.renderCounts(countsToRender, event.target.closest('.js-filter'));
  }

  static renderActiveFacets(html) {
    const activeFacetElementSelectors = ['.active-facets-mobile', '.active-facets-desktop'];

    activeFacetElementSelectors.forEach((selector) => {
      const activeFacetsElement = html.querySelector(selector);
      if (!activeFacetsElement) return;
      document.querySelector(selector).innerHTML = activeFacetsElement.innerHTML;
    });

    FacetFiltersForm.toggleActiveFacets(false);
  }

  static renderAdditionalElements(html) {
    const mobileElementSelectors = ['.mobile-facets__open', '.mobile-facets__count', '.sorting', '.mobile-facets__actions button', '.mobile-facets__sort summary', '.facets__total-results'];

    mobileElementSelectors.forEach((selector) => {
      if (!html.querySelector(selector)) return;
      document.querySelector(selector).innerHTML = html.querySelector(selector).innerHTML;
    });

    document.getElementById('FacetFiltersFormMobile').closest('filters-drawer').bindEvents();
  }

  static renderCounts(source, target) {
    const targetElement = target.querySelector('.facets__selected');
    const sourceElement = source.querySelector('.facets__selected');

    const targetElementAccessibility = target.querySelector('.facets__summary');
    const sourceElementAccessibility = source.querySelector('.facets__summary');

    if (sourceElement && targetElement) {
      target.querySelector('.facets__selected').outerHTML = source.querySelector('.facets__selected').outerHTML;
    }

    if (targetElementAccessibility && sourceElementAccessibility) {
      target.querySelector('.facets__summary').outerHTML = source.querySelector('.facets__summary').outerHTML;
    }
  }

  static updateURLHash(searchParams) {
    history.pushState({ searchParams }, '', `${window.location.pathname}${searchParams && '?'.concat(searchParams)}`);
  }

  static getSections() {
    return [
      {
        section: document.getElementById('product-grid').dataset.id,
      },
    ];
  }

  createSearchParams(form) {
    const formData = new FormData(form);
    return new URLSearchParams(formData).toString();
  }

  onSubmitForm(searchParams, event) {
    FacetFiltersForm.renderPage(searchParams, event);
  }

  onSubmitHandler(event) {
    event.preventDefault();
    
    if(event.target.name === "sort_by") {
      event.target.closest('details').removeAttribute('open')
    }
    
    const sortFilterForms = document.querySelectorAll('facet-filters-form form');
    if (event.srcElement.className == 'mobile-facets__checkbox') {
      const searchParams = this.createSearchParams(event.target.closest('form'));
      this.onSubmitForm(searchParams, event);
    } else {
      const forms = [];
      const isMobile = event.target.closest('form').id === 'FacetFiltersFormMobile';

      sortFilterForms.forEach((form) => {
        if (!isMobile) {
          if (form.id === 'FacetSortForm' || form.id === 'FacetFiltersForm' || form.id === 'FacetSortDrawerForm') {
            const noJsElements = document.querySelectorAll('.no-js-list');
            noJsElements.forEach((el) => el.remove());
            forms.push(this.createSearchParams(form));
          }
        } else if (form.id === 'FacetFiltersFormMobile') {
          forms.push(this.createSearchParams(form));
        }
      });
      this.onSubmitForm(forms.join('&'), event);
    }
  }

  onActiveFilterClick(event) {
    event.preventDefault();
    FacetFiltersForm.toggleActiveFacets();
    const url =
      event.currentTarget.href.indexOf('?') == -1
        ? ''
        : event.currentTarget.href.slice(event.currentTarget.href.indexOf('?') + 1);
    FacetFiltersForm.renderPage(url);
  }
}

FacetFiltersForm.filterData = [];
FacetFiltersForm.searchParamsInitial = window.location.search.slice(1);
FacetFiltersForm.searchParamsPrev = window.location.search.slice(1);
customElements.define('facet-filters-form', FacetFiltersForm);
FacetFiltersForm.setListeners();

class PriceRange extends HTMLElement {
  constructor() {
    super();
    this.querySelectorAll('input').forEach((element) =>
      element.addEventListener('change', this.onRangeChange.bind(this))
    );
    this.setMinAndMaxValues();
  }

  onRangeChange(event) {
    this.adjustToValidValues(event.currentTarget);
    this.setMinAndMaxValues();
  }

  setMinAndMaxValues() {
    const inputs = this.querySelectorAll('input');
    const minInput = inputs[0];
    const maxInput = inputs[1];
    if (maxInput.value) minInput.setAttribute('max', maxInput.value);
    if (minInput.value) maxInput.setAttribute('min', minInput.value);
    if (minInput.value === '') maxInput.setAttribute('min', 0);
    if (maxInput.value === '') minInput.setAttribute('max', maxInput.getAttribute('max'));
  }

  adjustToValidValues(input) {
    const value = Number(input.value);
    const min = Number(input.getAttribute('min'));
    const max = Number(input.getAttribute('max'));

    if (value < min) input.value = min;
    if (value > max) input.value = max;
  }
}

customElements.define('price-range', PriceRange);

class FacetRemove extends HTMLElement {
  constructor() {
    super();
    const facetLink = this.querySelector('a');
    facetLink.setAttribute('role', 'button');
    facetLink.addEventListener('click', this.closeFilter.bind(this));
    facetLink.addEventListener('keyup', (event) => {
      event.preventDefault();
      if (event.code.toUpperCase() === 'SPACE') this.closeFilter(event);
    });
  }

  closeFilter(event) {
    event.preventDefault();
    const form = this.closest('facet-filters-form') || document.querySelector('facet-filters-form');
    form.onActiveFilterClick(event);
  }
}

customElements.define('facet-remove', FacetRemove);

class LayoutSwitcher extends HTMLElement {
  constructor() {
    super();

    this.gridBtn = this.querySelector("#grid-view");
    this.listBtn = this.querySelector("#list-view");

    this.bindEvents();
  }

  bindEvents() {
    this.gridBtn.addEventListener('click', () => this.switchLayout(true))
    this.listBtn.addEventListener('click', () => this.switchLayout(false))
  }

  switchLayout(isGrid) {
    const productContainer = document.getElementById('product-grid')
    if (isGrid) {
      productContainer.classList.add("grid-layout");
      productContainer.classList.remove("list-layout");
      this.gridBtn.setAttribute("aria-pressed", "true");
      this.listBtn.setAttribute("aria-pressed", "false");
    } else {
      productContainer.classList.add("list-layout");
      productContainer.classList.remove("grid-layout");
      this.gridBtn.setAttribute("aria-pressed", "false");
      this.listBtn.setAttribute("aria-pressed", "true");
    }
  }
}

customElements.define('layout-switcher', LayoutSwitcher);